import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, Navigate, Redirect } from "react-router-dom";
import { InputFieldOptions } from "../Components/InputField";
import {
  getCurrentUser,
  updateUserData,
  verifyLogin,
  getOrders,
  deleteAccount,
  getSubscriptions,
} from "./api";
import { AccountInfo } from "../Components/account_info";
import { OrderInfo } from "../Components/order_info";
import Header from "../Components/header";
import Footer from "../Components/footer";
import { SubscriptionDetails } from "../Components/abbonamento_info";

const Profile = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [userData, setuserData] = useState({
    nome: "",
    cognome: "",
    email: "",
    num_tel: "",
    comune: "",
    cap: "",
    indirizzo: "",
    provincia: "",
  });
  const [defaultUserData, setDefaultUserData] = useState({
    userData,
  });
  const [loading, setLoading] = useState(true);
  const [loggedIn, setUserLogged] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [option, setOption] = useState("Informazioni Account");
  const [orderData, setOrderData] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState([]);

  const navigation = [
    { name: "Informazioni Account", href: "/" },
    { name: "Ordini", href: "/" },
    { name: "Abbonamento e pagamenti", href: "#" },
  ];

  const cancelModify = (e) => {
    e.preventDefault();
    setuserData(defaultUserData);
  };

  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const loggedIn = await verifyLogin();
        setUserLogged(loggedIn);
        if (!loggedIn) {
          localStorage.clear();
        }
      } catch (error) {
        console.error("Errore nel verificare la sessione:", error);
      } /*finally {
        setLoading(false);
      }*/
    };

    checkUserSession();
  }, []);

  const logout = async () => {
    axios.defaults.withCredentials = true;
    try {
      const response = await axios.get(`${API_URL}/logout`, {});
      localStorage.clear();
      setLoggingOut(true);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDeleteAccount = async (e) => {
    e.preventDefault();
    try {
      //alert("Sei sicuro di voler eliminare il tuo account?");
      console.log("Cancellazione account");
      const response = await deleteAccount();
      //localStorage.clear();
      //setLoggingOut(true);
      return <Navigate to="/login" state={{ expired: false }} />;
    } catch (err) {
      console.log(err);
    }
  };

  const selectOption = (name) => {
    //alert(name);
    setOption(name);
  };

  //RETRIEVE USER DATA
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getCurrentUser();
        console.log("QUI");
        console.log(data.user);
        if (data.user) {
          setuserData(data.user);
          setDefaultUserData(data.user);
        }
      } catch (error) {
        console.error("Errore nel caricamento dell'utente:", error);
      } finally {
        setLoading(false); // Fine caricamento
      }
    };

    fetchUser();
  }, []);

  //RETRIEVE SUBSCRIPTION DATA
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSubscriptions();
        console.log("RESPONSE: ", response);

        if (response.subscribed == false) {
          console.log("QUI");
          setSubscriptionData(false);
        } else {
          console.log("QUI2");
          setSubscriptionData(response);
        }
      } catch (error) {
        console.error("Errore nel fetch dei dati:", error);

        //setError("Si è verificato un errore durante il fetch dei dati.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [API_URL]);

  const handleChange = (e) => {
    console.log(e.target.value);
    console.log(userData);
    const { id, value } = e.target;
    console.log("ID: ", id);
    console.log("VALUE: ", value);
    setuserData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleNumberChange = (e) => {
    const { id, value } = e.target;
    if (/^\d*$/.test(value) && value.length <= 10) {
      // Controlla se il valore contiene solo numeri
      console.log(id);
      console.log(value);
      setuserData({ ...userData, [id]: value });
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      const loggedIn = await verifyLogin();
      setUserLogged(loggedIn);
    };

    checkUser();
  }, []);

  const handleUpdate = (e) => {
    const indirizzo_completo = {
      comune: userData.comune,
      cap: userData.cap,
      indirizzo: userData.indirizzo,
      provincia: userData.provincia,
    };
    const response = updateUserData(
      userData.nome,
      userData.cognome,
      userData.email,
      indirizzo_completo,
      userData.num_tel
    );
    console.log(response);
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await getOrders();
        setOrderData(response);
      } catch (error) {
        console.error("Errore nel caricamento degli ordini:", error);
      }
    };
    fetchOrders();
  }, []);

  if (loggingOut) {
    // Reindirizza alla pagina di login quando `loggingOut` è true
    return <Navigate to="/login" />;
  }

  if (loading) return <div>Loading...</div>;

  if (!loggedIn) {
    return <Navigate to="/login" state={{ expired: true }} />;
    //return <Navigate to={{ pathname: "/login", state: { expired: true } }} />;
  }

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      <Header />
      <div className="bg-gray-100 w-full mx-auto min-h-[500px] flex flex-col flex-grow md:flex-row md:mt-8 justify-start items-center md:justify-center md:items-start">
        {/*container */}
        {/* Sidebar */}
        <div className="mr-2 sm:w-[50%] md:w-[18%] min-h-max max-w-64 sm:p-8 bg-gray-100 md:border-r border-r-gray-200 flex justify-center w-full md:h-[calc(100vh-110px)] sm:justify-start md:fixed left-0">
          <ul className="w-screen sm:text-left text-sm space-y-2 flex md:flex-col flex-row items-center md:items-center bg-bslue-400">
            {navigation.map((item) => (
              <li key={item.name} className="w-full">
                <p
                  href="#"
                  onClick={() => selectOption(item.name)}
                  className={`block text-gray-700 font-semibold p-2 rounded cursor-pointer ${
                    option === item.name
                      ? "bg-gray-300 shadow-[inset_0_0px_3px_rgba(0,0,0,0.2)]"
                      : ""
                  }`}
                >
                  {item.name}
                </p>
              </li>
            ))}
          </ul>
        </div>
        {/* Main Content */}
        <div className="w-full lg:max-w-[60%] sm:w-4/6 md:mr-60 bg-white p-6 rounded-lg mt-4 md:mt-0 md:ml-56">
          {/*shadow-lg  */}
          <div>
            {option === "Informazioni Account" && (
              <AccountInfo
                handleChange={handleChange}
                handleUpdate={handleUpdate}
                userData={userData}
                logout={logout}
                cancelModify={cancelModify}
                deleteAccount={fetchDeleteAccount}
                handleNumberChange={handleNumberChange}
              />
            )}
            {option === "Ordini" && <OrderInfo orders={orderData} />}
            {option === "Abbonamento e pagamenti" && (
              <SubscriptionDetails subscriptionData={subscriptionData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
